import { Pipe, PipeTransform } from '@angular/core';

/**
 * @desc This pipe maps an enum type to an object-literal representation.
 */
@Pipe({
  name: 'enum'
})
export class EnumPipe implements PipeTransform {
  transform<T = unknown, K = string | number>(enumType: T): { [key: string]: T } {
    return this.makeObject(enumType);
  }

  private makeObject<T = unknown, K = string | number>(enumType: T): { [key: string]: T } {
    return Object.keys(enumType)
      .filter(key => isNaN(Number(key)))
      .reduce((acc, currKey) => {
        acc[currKey] = enumType[currKey];
        return acc;
      }, {});
  }
}
